'use client';

import { c as _c } from "react/compiler-runtime";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@icons/classic/regular';
import { InputTableFilter } from './InputTableFilter';
import type { InputProps } from '../../components';
import type { BaseTableFilterProps } from './types';
export interface SearchTableFilterProps extends BaseTableFilterProps {
  searchParam?: string;
  variant: 'search';
  componentProps?: Partial<InputProps & {
    'data-testid'?: string;
  }>;
  placeholder: string;
  infoTooltip?: string;
  containerClassName?: string;
  filterOptions?: never;
  groups?: never;
  fromDateParam?: never;
  toDateParam?: never;
  value?: never;
}
export function SearchTableFilter(t0) {
  const $ = _c(11);
  const {
    className,
    containerClassName: t1,
    searchParam: t2,
    searchParamsToClearOnChange,
    componentProps,
    placeholder,
    filterType
  } = t0;
  const containerClassName = t1 === undefined ? "w-full md:max-w-72" : t1;
  const searchParam = t2 === undefined ? "filter" : t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <FontAwesomeIcon icon={faSearch} />;
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] !== componentProps) {
    t4 = {
      prefix: t3,
      ...componentProps
    };
    $[1] = componentProps;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const defaultComponentProps = t4;
  let t5;
  if ($[3] !== className || $[4] !== containerClassName || $[5] !== defaultComponentProps || $[6] !== filterType || $[7] !== placeholder || $[8] !== searchParam || $[9] !== searchParamsToClearOnChange) {
    t5 = <InputTableFilter className={className} componentProps={defaultComponentProps} containerClassName={containerClassName} filterType={filterType} placeholder={placeholder} searchParam={searchParam} searchParamsToClearOnChange={searchParamsToClearOnChange} variant="input" />;
    $[3] = className;
    $[4] = containerClassName;
    $[5] = defaultComponentProps;
    $[6] = filterType;
    $[7] = placeholder;
    $[8] = searchParam;
    $[9] = searchParamsToClearOnChange;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}